/* istanbul ignore file - This needs to be refactored to test */
/**
 * @file
 * Behaviors for the Service Menu.
 */
!(function (Drupal, $) {
  'use strict';
  /**
   * Setup and attach the Service Menu behaviors.
   *
   * @type {Drupal~behavior}
   */

  Drupal.behaviors.serviceNav = {
    attach: function attach(context) {
      const $secondaryWraper = $('.services--menu-block', context);

      if (!$secondaryWraper.length) {
        return;
      }

      const $secondaryToggle = $('.services__toggle', context);
      const $secondaryNav = $('.sidebar-nav--content', context);

      // Apply active class on click.
      $secondaryToggle.on('click', function () {
        $secondaryNav.toggleClass('active');
        $secondaryToggle.toggleClass('active');
      });
    },
  };
})(Drupal, jQuery);
